import React from 'react';
import styled, { keyframes } from 'styled-components';
import { lighten } from 'polished';
import theme, { combineValues } from '@cld/theme-helper';
import { iconMixin } from '@cld/icon';

const Svg = styled.svg.attrs((props) => ({
  size: props.size || 'md',
  variant: props.variant || 'primary',
}))`
  width: ${(props) => iconMixin(props, { asObject: true }).width};
  position: relative;

  path {
    stroke-dasharray: 280;
    stroke-dashoffset: 0;
    transform-origin: center;
  }
`;

const dashKeyframes = keyframes`
    0% { stroke-dashoffset: 560; }
    50% { stroke-dashoffset: 0; }
    100% { stroke-dashoffset: 560;}
`;

const getColorKeyframes = (color) => keyframes`
    0% { stroke: ${color}; }
    50% { stroke: ${color ? lighten(0.2, color) : ''}; }
    100% { stroke: ${color}; }
`;

const Path = styled.path`
  animation: ${dashKeyframes} 2s ease-in-out infinite, ${combineValues(theme`palette.${'variant'}`, getColorKeyframes)} 8s ease-in-out infinite;
`;

const ProgressLogo = React.forwardRef(({ variant, ...props }, ref) => (
  <Svg ref={ref} {...props} viewBox="-4 -4 151 100" preserveAspectRatio="xMidYMid" data-test="progress">
    <Path
      // eslint-disable-next-line max-len
      d="M121.663 90.638c-1.796 0-99.33-.498-101.474-1.478C8.685 83.877 1.25 72.196 1.25 59.396c0-16.656 12.797-30.61 29.052-32.323 7.49-15.706 23.186-25.707 40.714-25.707 20.98 0 39.215 14.752 43.945 34.907 15.09.245 27.29 12.63 27.29 27.822 0 11.968-7.738 22.55-19.256 26.33"
      strokeWidth="9"
      strokeLinecap="round"
      fill="none"
      fillRule="evenodd"
      variant={variant}
    />
  </Svg>
));

ProgressLogo.defaultProps = {
  //size: 'xl',
};

export default ProgressLogo;
